import { useNavigate } from 'react-router-dom'

import { useCopilotAction } from '@copilotkit/react-core'

/**
 * Navigate the user to a given path or URL within the application.
 */
export const useNavigateAction = () => {
  const navigate = useNavigate()

  useCopilotAction({
    name: 'navigate',
    available: 'remote',
    description:
      'Navigate the user to a given path or URL within the application. Use when the user asks to go to a specific page.',
    parameters: [
      {
        name: 'path',
        description: 'The path to navigate to (e.g. /settings, /team).',
        required: true,
      },
      {
        name: 'followUp',
        description: 'A follow-up message to send after the navigation.',
        required: false,
      },
    ],
    handler: async ({ path, followUp }) => {
      navigate(path)
      return 'Navigation successful' + (followUp ? `\n${followUp}` : '')
    },
  })
}
